import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { RestApiService } from '@core/services/rest-api.service';
import {
  DvDynamicFormModule,
  DvDynamicFormUtils,
  DvFormUtils,
  DvTextboxElement,
  FormOf,
} from '@devinco/ui/legacy';
import { ReportInformationTabDto } from '@pages/reports-page/components/report-tabs/report-information-tab/interfaces';
import { ReportInformationTabService } from '@pages/reports-page/components/report-tabs/report-information-tab/services/report-information-tab.service';
import { ReportFilterFormService } from '@pages/reports-page/components/report-tabs/report-information-tab/services/report-filter-form.service';
import { SplitterWithGridHelperService } from '@features/vt-grid/services/splitter-with-grid-helper.service';
import { TranslateModule } from '@ngx-translate/core';
import { Entity } from '@shared/constants/entity';
import { switchMap } from 'rxjs';
import { PipesModule } from '@shared/pipes/pipes.module';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';

@Component({
  imports: [
    DvDynamicFormModule,
    PipesModule,
    DvDialogContentComponent,
    DvButtonComponent,
    TranslateModule,
  ],
  selector: 'app-copy-report-dialog',
  templateUrl: './copy-report-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ReportInformationTabService, SplitterWithGridHelperService],
})
export class CopyReportDialogComponent
  extends DvDialogContent<{ entityId: string }, CopyReportDialogComponent>
  implements OnInit
{
  private api = inject(RestApiService);
  private reportInfoTabService = inject(ReportInformationTabService);
  private gridEntityService = inject(SplitterWithGridHelperService);
  private reportFilterFormService = inject(ReportFilterFormService);

  reportNameElement = new DvTextboxElement({
    colspan: 12,
    key: 'ReportDescription',
    label: 'Report.ReportDescription',
    validators: [Validators.required],
  });

  formGroup: FormGroup<
    FormOf<Pick<ReportInformationTabDto, 'ReportDescription'>>
  >;

  ngOnInit(): void {
    this.formGroup = DvFormUtils.createFormGroup(
      [this.reportNameElement],
      true
    );
  }

  performSave(): void {
    const requestKeys = DvDynamicFormUtils.getKeysForRequest([
      ...this.reportInfoTabService.getMainElements(),
      ...this.reportFilterFormService.filterElements,
      ...this.reportInfoTabService.getReceiverElements(),
      ...this.reportInfoTabService.getRecurrenceElements(),
      ...this.reportInfoTabService.getMonthFrequencyElements(),
      ...this.reportInfoTabService.getWeekFrequencyElements(),
      ...this.reportInfoTabService.getYearFrequencyElements(),
    ]).filter(
      field => !this.reportInfoTabService.excludedRequestValues.includes(field)
    );
    this.api
      .getInfo<ReportInformationTabDto>(
        Entity.ReportSetting,
        this.data.entityId,
        requestKeys
      )
      .pipe(
        switchMap(resp =>
          this.api.upsert(Entity.ReportSetting, '0', {
            ...resp,
            ReportDescription: this.formGroup.controls.ReportDescription.value,
          })
        )
      )
      .subscribe(id => {
        if (!id) return;
        this.gridEntityService.addNewlyCreatedItemToGrid(
          Entity.ReportSetting,
          id
        );
        this.dialogRef.onConfirm();
      });
  }

  cancel(): void {
    this.dialogRef.onCancel();
  }
}
